"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

export function useIsProductPage() {
	const pathname = usePathname();
	const [isProduct, setIsProduct] = useState(false);

	useEffect(() => {
		let cancelled = false;

		async function check() {
			if (!pathname || pathname === "/") {
				setIsProduct(false);
				return;
			}
			const slugPath = pathname.replace(/^\//, "");
			if (!slugPath || slugPath.includes("/")) {
				setIsProduct(false);
				return;
			}
			try {
				const catRes = await fetch(`/api/categories/${slugPath}`);
				const isCat = catRes.ok && (await catRes.json())?.productsData ? true : false;
				if (cancelled) return;
				if (isCat) {
					setIsProduct(false);
					return;
				}
				const pRes = await fetch(`/api/products/${slugPath}`);
				if (!cancelled) setIsProduct(pRes.ok);
			} catch {
				if (!cancelled) setIsProduct(false);
			}
		}
		check();

		return () => {
			cancelled = true;
		};
	}, [pathname]);

	return isProduct;
}
